<template>
  <div class="secret-modal">
    <button @click="$emit('closeSecretModal')" class="close-button">
      <i class="icon-close-big fz15"></i>
    </button>
    <p>
      Код раздела:
      <span>{{ model.checkedCategory.id }}</span>
    </p>

    <p class="secret-sections mb-3">
      Код категории:
      <span>{{ model.checkedType.id }}</span>
    </p>

    <p class="secret-sections mb-3">
      Код подкатегории:
      <span>{{ model.checkedClass.id }}</span>
    </p>

    <p class="secret-sections mb-3">
      Здания:
      <span v-for="(el, i) in model.objects" :key="el.id">{{ el.id }}<span v-if="i !== model.objects.length-1">|</span>
      </span>
    </p>

    <p class="secret-sections mb-3">
      Помещения:
      <span v-for="(el, i) in model.aparts" :key="el.id">{{ el.id }}<span v-if="i !== model.aparts.length-1">|</span>
      </span>
    </p>

    <p class="secret-sections mb-3">
      Материалы:
      <span v-for="(el, i) in model.materials" :key="el.id">{{ el.id }}<span v-if="i !== model.materials.length-1">|</span>
      </span>
    </p>
    <div class="classification-select mt-6 mb-9">

      <!-- Разделы -->
      <multiselect
        v-model="model.checkedCategory"
        :options="category"
        :allow-empty="false"
        :searchable="false"
        :show-labels="false"
        :max-height="246"
        placeholder="Выберите раздел"
        :preselect-first="false"
        @input="changeSelect('category')"
        label="text"
        track-by="id"
        id="category"
        class="mb-3"
        name="category"
      ></multiselect>

      <!-- Категории -->
      <multiselect
        v-if="typeList.length"
        v-model="model.checkedType"
        :options="typeList"
        :allow-empty="false"
        :searchable="false"
        :show-labels="false"
        :max-height="246"
        placeholder="Выберите категорию"
        :preselect-first="false"
        label="text"
        track-by="id"
        @input="changeSelect('type')"
        id="category"
        class="mb-3"
        name="category"
      ></multiselect>

      <!-- Подкатегории -->
      <multiselect
        v-if="classesList.length"
        v-model="model.checkedClass"
        :options="classesList"
        :allow-empty="false"
        :searchable="false"
        :show-labels="false"
        :max-height="246"
        placeholder="Выберите подкатегорию"
        :preselect-first="false"
        @input="changeSelect('classes')"
        label="text"
        track-by="id"
        id="category"
        class="mb-3"
        name="category"
      ></multiselect>

      <!-- Объекты -->
      <multiselect
        v-model="model.objects"
        :options="objects"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :show-labels="false"
        placeholder="Выберите здания"
        label="text"
        track-by="id"
        :preselect-first="false"
        class="mb-3"
      >
        <template slot="selection">
          <span
            class="multiselect__single"
            v-if="model.objects.length"
          >Зданий выбрано: {{ model.objects.length }}</span>
        </template>
      </multiselect>

      <!-- Помещения -->
      <multiselect
        v-model="model.aparts"
        :options="aparts"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :show-labels="false"
        placeholder="Выберите помещения"
        label="text"
        track-by="id"
        :preselect-first="false"
        class="mb-3"
      >
        <template slot="selection">
          <span
            class="multiselect__single"
            v-if="model.aparts.length"
          >Помещений выбрано: {{ model.aparts.length }}</span>
        </template>
      </multiselect>

      <!-- Материалы -->
      <multiselect
        v-model="model.materials"
        :options="materials"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :show-labels="false"
        placeholder="Выберите материалы"
        label="text"
        track-by="id"
        :preselect-first="false"
      >
        <template slot="selection">
          <span
            class="multiselect__single"
            v-if="model.materials.length"
          >Материалов выбрано: {{ model.materials.length }}</span>
        </template>
      </multiselect>
    </div>
    <div class="d-flex">
      <v-btn @click="reset()" color="gray" class="mr-6">Сбросить</v-btn>
      <v-btn @click="$emit('closeSecretModal')" color="gray">Закрыть</v-btn>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
export default {
  data: () => ({
    category: [],
    typeList: [],
    classesList: [],
    objects: [],
    aparts: [],
    materials: [],
    model: {
      checkedCategory: [],
      checkedType: [],
      checkedClass: [],
      objects: [],
      aparts: [],
      materials: [],
    },
  }),
  created () {
    this.getCategories()
    this.getData()
  },
  methods: {
    reset () {
      this.model.checkedCategory = []
      this.model.checkedType = []
      this.typeList = []
      this.classesList = []
      this.model.checkedClass = []
      this.model.objects = []
      this.model.aparts = []
      this.model.materials = []
    },
    changeSelect (select) {
      switch (select) {
        case 'category':
          this.getType()
          break
        case 'type':
          this.getClasses()
          break
        case 'classes':
          // this.$store.dispatch("checkedClassStore", this.model.checkedClass.id);
          break
      }
    },
    /**
     * Получение разделов при открытии модалки
     */
    getCategories () {
      this.$store.dispatch('getSectionData')
        .then(category => {
          this.category.push(...category)
        })
        .catch(err => console.error(err))
    },
    async getType () {
      this.typeList = []
      this.classesList = []
      this.model.checkedClass = []
      this.typeList = await this.$store.dispatch('getTypeFromStore', this.model.checkedCategory.id)
      this.model.checkedType = []
    },
    async getClasses () {
      this.classesList = []
      this.model.checkedClass = []
      this.classesList = await this.$store.dispatch(
        'getClassFromStore',
        this.model.checkedType.id,
      )
    },
    getData () {
      Promise.all([
        this.$store.dispatch('getObjectsTypesData'),
        this.$store.dispatch('getApartsData'),
        this.$store.dispatch('getMaterialsData'),
      ])
        .then(([objectsType, aparts, materials]) => {
          //Спсиок объектов
          this.objects.push(...objectsType)
          //Спсиок помещений
          this.aparts.push(...aparts)
          //Спсиок материалов
          this.materials.push(...materials)
        })
        .catch(err => {
          throw new Error(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.secret-modal {
  position                  : fixed;
  right                     : 0;
  top                       : 50vh;
  transform                 : translateY(-50%);
  background-color          : $bg-main;
  padding                   : 32px;
  border-top-left-radius    : 5px;
  border-bottom-left-radius : 5px;
  box-shadow                : 0 0 2rem 0 rgba(0, 0, 0, 0.2);
  z-index                   : 100;
  width                     : 500px;

  .secret-sections {
    display   : flex;
    flex-wrap : wrap;
  }

  span {
    font-weight : bold;
  }
}

.close-button {
  position : absolute;
  right    : 14px;
  top      : 14px;
}
</style>
